// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2ndG4","options":"AnswerScale_options__3H4HG","selected":"AnswerScale_selected__2bRCz"};